/// <reference path="../../app.definition.ts" />

import { SearchResult } from "@common/model/searchResult";
import { IUtilityService } from "@common/service/util.service";
import angular from "angular";
import moment from "moment";


function searchFilter($_util: IUtilityService) {
    return function (items: SearchResult[], filterObj: SearchResult) {
        const retVals: SearchResult[] = [];
        // console.log("SF -> starting items:", items);

        for (let item of (items || [])) {
            let push = true;
            // console.log('SF -> Filter by title?', !!filterObj.title && filterObj.title.length > 0 ? "Yes: " + filterObj.title : "No");
            // console.log("test $_util: ", item.title, filterObj.title, $_util.stringContains(item.title, filterObj.title));
            if (!!filterObj.title && filterObj.title.length > 0 && !$_util.stringContains(item.title, filterObj.title)) {
                push = false;
            }

            // console.log('SF -> Filter by authorFullName?', !!filterObj.authorFullName && filterObj.authorFullName.length > 0 ? "Yes: " + filterObj.authorFullName : "No");
            // console.log("test $_util: ", item.authorFullName, filterObj.authorFullName, $_util.stringContains(item.authorFullName, filterObj.authorFullName));
            if (!!filterObj.authorFullName && filterObj.authorFullName.length > 0 && !$_util.stringContains(item.authorFullName, filterObj.authorFullName)) {
                push = false;
            }
            console.log('SF -> Filter by crFullName?', !!filterObj.crFullName && filterObj.crFullName.length > 0 ? "Yes: " + filterObj.crFullName : "No");
            console.log("test $_util: ", item.crFullName, filterObj.crFullName, $_util.stringContains(item.crFullName, filterObj.crFullName));
            if (!!filterObj.crFullName && filterObj.crFullName.length > 0 && !$_util.stringContains(item.crFullName, filterObj.crFullName)) {
                push = false;
            }

            // console.log(item.date, 'is between', filterObj.date || 'beginning of time', 'and', filterObj.endDate || 'infinity', '?', moment(item.date).isBetween(filterObj.date || 0, filterObj.endDate || null, 'day', '[]') ? 'Yes' : 'No')
            if (!!filterObj.date && moment(item.date).isAfter(moment(filterObj.date), 'day')) {
                push = false;
            }

            // console.log(item.date, 'is between', filterObj.date || 'beginning of time', 'and', filterObj.endDate || 'infinity', '?', moment(item.date).isBetween(filterObj.date || 0, filterObj.endDate || null, 'day', '[]') ? 'Yes' : 'No')
            if (!!filterObj.endDate && moment(item.date).isBefore(moment(filterObj.endDate), 'day')) {
                push = false;
            }

            // console.log(item.date, 'is between', filterObj.date || 'beginning of time', 'and', filterObj.endDate || 'infinity', '?', moment(item.date).isBetween(filterObj.date || 0, filterObj.endDate || null, 'day', '[]') ? 'Yes' : 'No')
            // if ((!!filterObj.date || !!filterObj.endDate) && item.date.getTime() > (filterObj.date.getTime() || 0) && item.date.getTime() > (filterObj.endDate.getTime() || 8640000000000000)) {
            //     push = false;
            // }

            !!push && retVals.push(item);
        }

        //
        // console.log('SF -> Filter by title?', !!filterObj.title && filterObj.title.length > 0 ? "Yes: " + filterObj.title : "No");
        // if (!!filterObj.title && filterObj.title.length > 0) {
        //     retVals = retVals.filter((item) => $_util.stringContains(item.title, filterObj.title));
        //     console.log('SF -> Title filtered results:', retVals);
        // }
        //
        // console.log('SF -> Filter by authorFullName?', !!filterObj.authorFullName && filterObj.authorFullName.length > 0 ? "Yes: " + filterObj.authorFullName : "No");
        // if (!!filterObj.authorFullName && filterObj.authorFullName.length > 0) {
        //     retVals = retVals.filter(
        //         item => {
        //             console.log("test $_util: ", item.authorFullName, filterObj.authorFullName, $_util.stringContains(item.authorFullName, filterObj.authorFullName));
        //             return $_util.stringContains(item.authorFullName, filterObj.authorFullName);
        //         }
        //     );
        //     console.log('SF -> Author filtered results:', retVals);
        // }

        // console.log('SF -> filtered results:', retVals);
        return retVals;
    }

}

angular.module('eCareVault.common.filters').filter('searchFilter', ['UtilityService', searchFilter]);
